exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.tree-list-blobs .file-row-name {\n  margin-left: 12px;\n}\n.diff-tree-search-shortcut {\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n.tree-list-icon:not(button) {\n  pointer-events: none;\n}\n", ""]);

